import { Link } from "react-router-dom";
import { Instagram, Mail } from "lucide-react";
import { Newsletter } from "./Newsletter";
import { BRAND } from "@/lib/content";

export const Footer = () => (
  <footer className="relative bg-[#47394E] text-[#E8DCCF] grain overflow-hidden" data-testid="site-footer">
    <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-20 lg:py-28 relative z-10">
      <div className="grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5">
          <img
            src="/jamie-logo.png"
            alt="Jamie M Rapavy — Coaching · Connecting · Clarifying"
            data-testid="footer-logo"
            className="h-20 w-auto brightness-0 invert"
          />
          <p className="font-display text-2xl lg:text-3xl mt-8 max-w-sm leading-snug text-[#E8DCCF]/90">
            Your next five bookings may be closer than you think.
          </p>
        </div>

        <div className="lg:col-span-3 lg:col-start-7">
          <p className="overline text-[#A8B39B] mb-5">Explore</p>
          <ul className="space-y-3 font-body">
            {[
              ["Coaching", "/coaching"],
              ["Community", "/community"],
              ["About Jamie", "/about"],
              ["The Journal", "/journal"],
              ["Book a Session", "/booking"],
              ["Contact", "/contact"],
            ].map(([label, to]) => (
              <li key={to}>
                <Link
                  to={to}
                  data-testid={`footer-link-${label.split(" ")[0].toLowerCase()}`}
                  className="text-[#E8DCCF]/70 hover:text-[#E8DCCF] transition-colors"
                >
                  {label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="lg:col-span-3">
          <p className="overline text-[#A8B39B] mb-5">The free guide</p>
          <p className="font-body text-sm text-[#E8DCCF]/70 mb-4">
            Get "Where Your Next 5 Bookings Are Hiding" — tell me where to send it.
          </p>
          <Newsletter dark />
          <div className="flex items-center gap-4 mt-8">
            <a href={`mailto:${BRAND.email}`} className="hover:text-[#A8B39B] transition-colors" aria-label="Email" data-testid="footer-email">
              <Mail size={20} />
            </a>
            <a href="https://instagram.com" target="_blank" rel="noreferrer" className="hover:text-[#A8B39B] transition-colors" aria-label="Instagram" data-testid="footer-instagram">
              <Instagram size={20} />
            </a>
          </div>
        </div>
      </div>

      <div className="mt-20 pt-8 border-t border-[#E8DCCF]/15 flex flex-col sm:flex-row justify-between gap-3 text-xs text-[#E8DCCF]/50 font-body">
        <span>© {new Date().getFullYear()} Jamie M Rapavy. All rights reserved.</span>
        <span>For established wedding professionals.</span>
      </div>
    </div>
  </footer>
);
